<template>
  <SqlDatasourceCard
    :datasourceId="this.$route.params.id"
    :dealerId="dealer.id"
    @on-save="$router.push({ name: 'sql_datasources_path' })"
  />
</template>

<script>
import SqlDatasourceCard from './SqlDatasourceCard.vue'
import { mapState } from 'vuex'

export default {
  components: {
    SqlDatasourceCard
  },
  computed: {
    ...mapState('DealerStore', ['dealer'])
  }
}
</script>
